import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { Answer, QuestionInPage, QuestionnaireAnswer } from 'src/app/core/models/questionnaire.model';
import { QuestionContext } from 'src/app/shared/components/simple/question-multi-file/question-multi-file.component';
import { ConfirmModalComponent } from 'src/app/shared/components/simple/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-edit-single-question',
  templateUrl: './edit-single-question.component.html',
  styleUrls: ['./edit-single-question.component.scss'],
})
export class EditSingleQuestionComponent implements OnInit{
  // last change emitted by the inner question component
  lastChange: { question: any; answer: Answer } | null = null;

  // provide a null observable for questionnaireAnswer (question.component expects an Observable)
  qa$: Observable<QuestionnaireAnswer | null> = of(null);

  context: QuestionContext = { claim_id: '' };

  constructor(
    public dialogRef: MatDialogRef<EditSingleQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { question: QuestionInPage; claimId?: string; user?: any },
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log('[EditSingleQuestionComponent] DATA', this.data);
    this.context = { claim_id: this.data.claimId ?? '' };
  }

  onChange(ev: any) {
    this.lastChange = ev;
  }

  closeCancel() {
    this.dialogRef.close({ ok: false });
  }

  private getCurrentAnswer(): Answer | null {
    return this.lastChange?.answer || this.data.question?.cp_question?.answer || null;
  }

  private hasValidationWarning(): boolean {
    const question = this.lastChange?.question || this.data.question?.cp_question;
    const answer = this.getCurrentAnswer();
    const value = answer?.value;
    const isEmpty =
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0);

    return (!question?.elective && isEmpty) || question?.isValid === false;
  }

  saveAndClose() {
    if (!this.hasValidationWarning()) {
      this.dialogRef.close({ ok: true, change: this.lastChange });
      return;
    }

    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'AdminQuestionnaireSaveWarningTitle',
        message: 'AdminQuestionnaireSaveWarningMessage',
        confirmText: 'AdminQuestionnaireSaveAnyway',
        cancelButton: 'AdminQuestionnaireCancel',
        emphasizeConfirm: true,
      },
    });

    ref.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogRef.close({ ok: true, change: this.lastChange });
      }
    });
  }
}
